(function () {
  function formatMoney(cents, currencyISO) {
    try {
      return new Intl.NumberFormat("en-GB", {
        style: "currency",
        currency: currencyISO || "GBP",
      }).format(cents / 100);
    } catch (e) {
      return "£" + (cents / 100).toFixed(2);
    }
  }

  function extractFirstInt(str) {
    const m = String(str || "").match(/(\d+)/);
    return m ? parseInt(m[1], 10) : 0;
  }

  function findOptionSelects(block) {
    // Best guess for product form
    const form =
      block.closest('form[action*="/cart/add"]') ||
      document.querySelector('form[action*="/cart/add"]') ||
      document;

    // New Standard / older Shopify themes commonly use these selectors
    const selects = form.querySelectorAll(
      'select[name^="options["], select.single-option-selector, select[id^="SingleOptionSelector"], select[data-index]'
    );

    return Array.from(selects);
  }

  function getSelectedOptionsInOrder(block, optionCount) {
    const selects = findOptionSelects(block);

    // If selects have data-index (0,1,2), sort by it
    const withIndex = selects.filter(s => s.dataset && s.dataset.index !== undefined);
    if (withIndex.length) {
      withIndex.sort((a, b) => parseInt(a.dataset.index, 10) - parseInt(b.dataset.index, 10));
      return withIndex.map(s => s.value).slice(0, optionCount);
    }

    // If ids like SingleOptionSelector-0 / -1 exist, sort by the number
    const withIdIndex = selects.filter(s => /^SingleOptionSelector-\d+$/.test(s.id || ""));
    if (withIdIndex.length) {
      withIdIndex.sort((a, b) => {
        const ai = parseInt(a.id.split("-").pop(), 10);
        const bi = parseInt(b.id.split("-").pop(), 10);
        return ai - bi;
      });
      return withIdIndex.map(s => s.value).slice(0, optionCount);
    }

    // Fallback: use DOM order
    return selects.map(s => s.value).slice(0, optionCount);
  }

  function renderTable(block) {
    const qtyIndex = parseInt(block.getAttribute("data-qty-option-index"), 10); // 1..3
    const currencyISO = block.getAttribute("data-currency-iso") || "GBP";

    const variantsEl = block.querySelector("[data-price-breaks-variants]");
    const packsEl = block.querySelector("[data-price-breaks-packs]");
    const body = block.querySelector("[data-price-breaks-body]");
    if (!variantsEl || !packsEl || !body || !qtyIndex) return;

    let variants, packsWanted;
    try {
      variants = JSON.parse(variantsEl.textContent || "[]");
      packsWanted = (JSON.parse(packsEl.textContent || "[]") || [])
        .map((n) => parseInt(n, 10))
        .filter(Boolean);
    } catch {
      return;
    }

    // Get selected option values in variant option order: option1, option2, option3
    const optionCount = (variants[0] && variants[0].options && variants[0].options.length) ? variants[0].options.length : 0;
    const selectedOptions = getSelectedOptionsInOrder(block, optionCount);

    if (!selectedOptions.length) {
      body.innerHTML = `<tr><td colspan="2" class="muted">Select options to see bulk prices</td></tr>`;
      return;
    }

    // Filter variants to match selected non-Quantity options
    const candidate = variants.filter((v) => {
      if (!v.available) return false;

      for (let i = 0; i < v.options.length; i++) {
        if (i === qtyIndex - 1) continue; // skip Quantity
        if (selectedOptions[i] && v.options[i] !== selectedOptions[i]) return false;
      }
      return true;
    });

    // Map qty -> variant
    const byQty = new Map();
    candidate.forEach((v) => {
      const qtyStr = v.options[qtyIndex - 1];
      const qty = extractFirstInt(qtyStr);
      if (!qty) return;
      if (!byQty.has(qty)) byQty.set(qty, v);
    });

    // Choose rows: preferred packs if present; else 4 smallest available
    let rows = [];
    packsWanted.forEach((q) => {
      if (byQty.has(q)) rows.push([q, byQty.get(q)]);
    });

    if (!rows.length) {
      rows = Array.from(byQty.entries())
        .sort((a, b) => a[0] - b[0])
        .slice(0, 4);
    }

    body.innerHTML = "";

    if (!rows.length) {
      body.innerHTML = `<tr><td colspan="2" class="muted">No bulk packs for this selection</td></tr>`;
      return;
    }

    rows.forEach(([qty, v], idx) => {
      const each = Math.floor(v.price / qty);
      const isBest = idx === rows.length - 1;

      const tr = document.createElement("tr");
      tr.innerHTML = `
        <td>Pack of ${qty}${isBest ? ' <span class="price-breaks__best">Best value</span>' : ""}</td>
        <td class="right">${formatMoney(each, currencyISO)}</td>
      `;
      body.appendChild(tr);
    });
  }

  function init() {
    document.querySelectorAll("[data-price-breaks]").forEach((block) => {
      renderTable(block);

      // Re-render when any dropdown changes (New Standard uses custom JS; this still catches real selects)
      const form =
        block.closest('form[action*="/cart/add"]') ||
        document.querySelector('form[action*="/cart/add"]') ||
        document;

      form.addEventListener("change", (e) => {
        if (e.target && e.target.tagName === "SELECT") renderTable(block);
      });
    });
  }

  if (document.readyState === "loading") document.addEventListener("DOMContentLoaded", init);
  else init();
})();




